'use strict';

angular.module('formApp').factory('resizeGuard', [
  '$window',
  'debounce',
  function ($window, debounce) {
    var guardians = [];

    var onResizeHandler = debounce(function (event) {
      var message;
      if (
        guardians.some(function (guardian) {
          return !!(message = guardian());
        })
      ) {
        (event || $window.event).returnValue = message;
        return message;
      } else {
        return undefined;
      }
    }, 200);

    var registerGuardian = function (guardianCallback) {
      guardians.unshift(guardianCallback);
      return function () {
        var index = guardians.indexOf(guardianCallback);
        if (index >= 0) {
          guardians.splice(index, 1);
        }
      };
    };

    if ($window.addEventListener) {
      $window.addEventListener('resize', onResizeHandler);
    } else {
      $window.onresize = onResizeHandler;
    }

    return {
      registerGuardian: registerGuardian
    };
  }
]);
